import { createFileRoute } from "@tanstack/react-router";
import { DealDetailsPage } from "../../../../../pages/deal-details-page/deal-details-page";

export const Route = createFileRoute("/_auth/_deal/deals/$dealId/details/$subProjectId")({
  component: DealDetailsPage,
});
